<mat-sidenav-container
  fullscreen
  [@.disabled]="(mini$ | async) === false"
  autosize>
  <!--
    Main sidenav. We change its zIndex because when dynamic sidenav is opened, backdrop
    would not cover main sidenav(which is in closed state). User can't click on main sidenav
    items while dynamic sidenav is opened.
  -->

  <mat-sidenav
    #sidenav="matSidenav"
    [mode]="(mobile$ | async) ? 'over' : 'side'"
    [opened]="
      (mobile$ | async) === false && (isLargeScreen$ | async)
        ? leftSidenavExpanded()
        : false
    "
    [autoFocus]="false"
    [class.mat-drawer-mini]="mini$ | async"
    [@size]="
      (isUploadRoute$ | async) ? 'hidden' : leftSidenavExpanded() ? '1' : '0'
    "
    [@.disabled]="isUploadRoute$ | async"
    [style.width.px]="
      (isUploadRoute$ | async)
        ? 0
        : leftSidenavExpanded()
          ? SIDENAV_W.expanded
          : SIDENAV_W.mini
    ">
    <qt-sidenav
      [mini]="mini$ | async"
      [expanded]="leftSidenavExpanded()"
      (sidenavToggle)="toggleLeftSidenav()"></qt-sidenav>
  </mat-sidenav>

  <mat-sidenav
    #rightSidenav="matSidenav"
    class="right-sidenav"
    mode="side"
    position="end"
    [opened]="false"
    [autoFocus]="false"
    fixedInViewport="true"
    [fixedTopGap]="0"
    [style.width.px]="rightPanelOpened() ? rightSidenavWidth() : 0">
    <qt-right-sidenav
      [mini]="mini$ | async"
      (closeSidenav)="toggleRightSidenav()"
      (widthChange)="onRightSidenavWidthChange($event)"
      (activeTabChange)="onRightSidenavTabChange($event)"
      (chatAvailabilityChange)="onChatAvailabilityChange($event)" />
  </mat-sidenav>

  <mat-sidenav-content
    class="layout__wrapper"
    [style.--layout-left-margin]="
      (isUploadRoute$ | async)
        ? '0px'
        : (mobile$ | async)
          ? '0px'
          : leftSidenavExpanded()
            ? '220px'
            : '70px'
    "
    [style.margin-right.px]="rightPanelOpened() ? rightSidenavWidth() : 0">
    @let impersonatedEmail = impersonatedEmail$ | async;
    <qt-toolbar
      class="layout__toolbar"
      (toggleToolbar)="toggleLeftSidenav()"
      (toggleRightPanel)="toggleRightSidenav()"
      (openAiChat)="openAiChat()"
      (openTasks)="toggleRightSidenavTab('tasks')"
      (addNote)="addNoteFromToolbar()"
      (addContact)="addContactFromToolbar()"
      (addDeal)="addDealFromToolbar()"
      [mini]="mini$ | async"
      [isLargeScreen]="isLargeScreen$ | async"
      [rightPanelOpened]="rightPanelOpened()"
      [rightPanelActiveTab]="rightSidenavActiveTab"
      [showAiChat]="canShowAiChat"></qt-toolbar>
    @if (isImpersonating()) {
      <div class="layout__impersonation-banner-row">
        <section
          class="layout__impersonation-banner"
          role="status"
          aria-live="polite">
          <div class="layout__impersonation-banner-text">
            {{ 'GNR_ADMIN_MODE_SIGNED_IN_OF' | translate }}
            @if (impersonatedEmail) {
              ({{ impersonatedEmail }}).
            } @else {
              {{ 'GNR_THE_SELECTED_USER' | translate }}.
            }
            {{ 'GNR_ACTIONS_WILL_BE_LOGGED' | translate }}
          </div>
          <button
            type="button"
            mat-flat-button
            class="layout__impersonation-banner-action"
            (click)="endImpersonationSession()">
            {{ 'GNR_END_SESSION' | translate }}
          </button>
        </section>
      </div>
    }
    <qt-network-error [error]="networkError$ | async"></qt-network-error>
    @if (ssoWelcome.welcome(); as welcome) {
      <qt-sso-welcome-banner
        @collapseEnterLeave
        [company]="welcome.company"
        [roleLabel]="welcome.roleLabel"
        (closed)="ssoWelcome.dismiss()" />
    }
    <main
      class="layout__content"
      [ngStyle]="{
        'background-color': router.url === '/' ? '#E7EFFD' : '#fff',
      }"
      #contentDiv>
      <div #childDiv>
        <router-outlet></router-outlet>
      </div>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
